/* CDL signature : direction A « Éteinte, puis allumée » (phase 2, 25/10/2026). Chargé en defer. */
(function () {
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
if (!('IntersectionObserver' in window)) return;

// A3 : la puce de teinte s'éclaire une fois, à sa première apparition complète à l'écran.
var chips = document.querySelectorAll('.cdl-teinte');
if (!chips.length) return;
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
entry.target.classList.add('is-lit');
io.unobserve(entry.target);
});
}, { threshold: 1 });
Array.prototype.forEach.call(chips, function (chip) { io.observe(chip); });
})();
